import React from 'react';

function SectionHeading(props) {
    return (
        <span className="page-section-header">
            <span className="heading">{props.heading}</span>
            {props.subHeading && (
                <span className="sub-heading">{props.subHeading}</span>
            )}
        </span>
    );
}

export default SectionHeading;
